import { FileText, CalendarCheck, CreditCard, Bot } from "lucide-react";
import { Reveal, Chapter, scrollToId } from "./shared";

const ITEMS = [
  {
    icon: FileText,
    title: "Custom Quoting Tools",
    desc: "Let customers build a detailed quote online, priced around your services.",
    testId: "custom-card-quoting",
  },
  {
    icon: CalendarCheck,
    title: "Online Booking",
    desc: "Let customers schedule appointments or reservations without a phone call.",
    testId: "custom-card-booking",
  },
  {
    icon: CreditCard,
    title: "Online Payments",
    desc: "Accept deposits, invoices, or full payments directly through your site.",
    testId: "custom-card-payments",
  },
  {
    icon: Bot,
    title: "AI Agent Automation",
    desc: "Automate follow-ups, scheduling, and customer questions with AI agents built for your business.",
    testId: "custom-card-ai",
  },
];

const CustomWork = () => (
  <section id="custom" className="py-16 sm:py-24 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto text-center flex flex-col items-center gap-4 mb-14">
        <Chapter num="02" label="Custom Development" />
        <Reveal delay={0.1}>
          <h2 className="text-3xl sm:text-4xl font-serif font-normal tracking-tight text-[#16324a]">
            Need More Than a Website?
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="text-base sm:text-lg text-[#334e68]">
            When you're ready, we also build custom web tools and automation around how your
            business actually runs.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={0.08 * i}>
            <div
              data-testid={item.testId}
              className="group h-full bg-white border border-[#e7e1d6] rounded-2xl p-6 sm:p-7 flex flex-col gap-4 hover:border-[#c99a43]/60 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-lg bg-[#eef1ee] text-[#c99a43] flex items-center justify-center group-hover:bg-[#e8c78f]/60 transition-colors duration-300">
                <item.icon size={20} />
              </div>
              <h3 className="font-serif text-xl font-medium text-[#16324a]">{item.title}</h3>
              <p className="text-sm text-[#334e68] leading-relaxed">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="text-center mt-12">
        <button
          data-testid="custom-cta-button"
          onClick={() => scrollToId("contact")}
          className="border border-[#16324a]/25 text-[#16324a] font-semibold text-sm sm:text-base px-7 py-3.5 rounded-full hover:border-[#c99a43] hover:text-[#c99a43] transition-colors duration-300"
        >
          Tell Us What You're Building
        </button>
        <p className="text-[13px] text-[#627d98] mt-4">
          Custom work is scoped and quoted individually, separate from the Growth plan.
        </p>
      </Reveal>
    </div>
  </section>
);

export default CustomWork;
